export const marketSegments = [
  { value: 'Adventure', label: 'Adventure' },
  { value: 'Business', label: 'Business' },
  { value: 'Cultural and Heritage', label: 'Cultural and Heritage' },
  { value: 'Eco-Tourism', label: 'Eco-Tourism' },
  { value: 'Family', label: 'Family' },
  { value: 'Group Travel', label: 'Group Travel' },
  { value: 'Health and Wellness', label: 'Health and Wellness' },
  { value: 'Luxury', label: 'Luxury' },
  { value: 'Senior Travel', label: 'Senior Travel' },
  { value: 'Sport Tourism', label: 'Sport Tourism' },
  { value: 'Student Travel', label: 'Student Travel' },
];

export const beddingConfigOptions = [
  { value: 'Single/Twin Bed', label: 'Single/Twin Bed' },
  { value: 'Double', label: 'Double' },
  { value: 'Queen Bed', label: 'Queen Bed' },
  { value: 'King Bed', label: 'King Bed' },
  { value: 'Sofa Bed', label: 'Sofa Bed' },
  { value: 'Roll Away', label: 'Roll Away' },
  { value: 'Dormitory Bed', label: 'Dormitory Bed' },
  { value: 'Other', label: 'Other' },
];

export const tourDurationOptions = [
  { value: 'Minute(s)', label: 'Minute(s)' },
  { value: 'Hour(s)', label: 'Hour(s)' },
  { value: 'Day(s)', label: 'Day(s)' },
  { value: 'Week(s)', label: 'Week(s)' },
  { value: 'Month(s)', label: 'Month(s)' },
  { value: 'Year(s)', label: 'Year(s)' },
];

export const roomCountOptions = [{ value: 'room', label: 'Rooms' }, { value: 'suite', label: 'Suites' }];

export const roomSizeOptions = [{ value: 'square meters', label: 'Square Meters' }, { value: 'square feet', label: 'Square Feet' }];

export const basicBuyerTypes = [
  'Inbound/Incoming/Receptive Tour Operator (ITO)',
  'Destination Management Company (DMC)',
  'Outbound/Outgoing Wholesaler',
  'Wholesaler',
  'Online Travel Agency (OTA)',
  'Retail Travel Agency',
];

export const DMOtypes = [
  'Destination Marketing Organization (DMO)',
  'National Tourism Board',
  'City & Regional Tourism Board',
  "Convention & Visitor's Bureau (CVB)",
];

export const otherBuyersTypes = [
  'Marketing Representation Agency',
  'Public Relations Agency',
  'Technology Provider',
  'Industry Member Organization/Association',
  'Media',
  'Other Provider',
];

export const contractorCompanyTypesFields = [
  ...basicBuyerTypes,
  ...DMOtypes,
  ...otherBuyersTypes,
];
export const contractorCompanyTypes = contractorCompanyTypesFields.map(str => ({
  value: str, label: str,
}));

export const accomCompanyTypesFields = [
  'Hotel',
  'Motel',
  'Hotel Chain',
  'Hostel',
  'Dormitory',
  'Hostel Group',
  'Holiday Homes',
  'Resort',
  'Apartments',
  'Bed & Breakfast',
  'Lodge',
  'Cottages',
  'Homestay/Farmstay',
  'Caravan Park',
];
export const accomCompanyTypes = accomCompanyTypesFields.map(str => ({
  value: str, label: str,
}));

export const nonAccomCompanyTypesFields = [
  'Attractions',
  'Day Tours/Excursions',
  'Multi-Day Tours',
  'Restaurant/Bar',
  'Transfers',
  'Auto Rental',
  'Dining',
  'Cruise Line',
  'Coach Tours',
  'Railway Operator',
  'Discount Ticket Passes',
];

export const nonAccomCompanyTypes = nonAccomCompanyTypesFields.map(str => ({
  value: str, label: str,
}));

export const amenitiesOptions = [
  { value: '24 Hour Reception', label: '24 Hour Reception' },
  { value: '24 Hour Room Service', label: '24 Hour Room Service' },
  { value: 'Advanced Eco Accredited', label: 'Advanced Eco Accredited' },
  { value: 'Air-Conditioning', label: 'Air-Conditioning' },
  { value: 'Apple TV', label: 'Apple TV' },
  { value: 'Babysitting Available', label: 'Babysitting Available' },
  { value: 'Baggage Holding Room', label: 'Baggage Holding Room' },
  { value: 'Baggage Storage', label: 'Baggage Storage' },
  { value: 'Baggage Storage (fees apply)', label: 'Baggage Storage (fees apply)' },
  { value: 'Balcony', label: 'Balcony' },
  { value: 'Bar Fridge', label: 'Bar Fridge' },
  { value: 'Bar on Premises', label: 'Bar on Premises' },
  { value: 'Barbecue', label: 'Barbecue' },
  { value: 'Bath', label: 'Bath' },
  { value: 'Bath Robes', label: 'Bath Robes' },
  { value: 'Bicycle Hire', label: 'Bicycle Hire' },
  { value: 'Blanket', label: 'Blanket' },
  { value: 'BOSE Sound System', label: 'BOSE Sound System' },
  { value: 'Business Service Available', label: 'Business Service Available' },
  { value: 'CD Player', label: 'CD Player' },
  { value: 'Cafe', label: 'Cafe' },
  { value: 'Car Charging Station', label: 'Car Charging Station' },
  { value: 'Ceiling Fan/s', label: 'Ceiling Fan/s' },
  { value: 'Central Heating', label: 'Central Heating' },
  { value: 'Child Activity Program', label: 'Child Activity Program' },
  { value: 'Child Minding Facilities', label: 'Child Minding Facilities' },
  { value: 'Child Wading Pool', label: 'Child Wading Pool' },
  { value: 'Children Not Catered For', label: 'Children Not Catered For' },
  { value: 'Children\'s Play Area', label: 'Children\'s Play Area' },
  { value: 'Clock Radio', label: 'Clock Radio' },
  { value: 'Clothes Dryer', label: 'Clothes Dryer' },
  { value: 'Combination Washer/Dryer', label: 'Combination Washer/Dryer' },
  { value: 'Communal Lounge', label: 'Communal Lounge' },
  { value: 'Conference Facilities', label: 'Conference Facilities' },
  { value: 'Cots Available', label: 'Cots Available' },
  { value: 'Courtesy Transfers', label: 'Courtesy Transfers' },
  { value: 'Currency Exchange', label: 'Currency Exchange' },
  { value: 'Cycle/Running Path', label: 'Cycle/Running Path' },
  { value: 'DVD Hire', label: 'DVD Hire' },
  { value: 'DVD Player', label: 'DVD Player' },
  { value: 'Day Spa', label: 'Day Spa' },
  { value: 'Day Tours/Tour Desk', label: 'Day Tours/Tour Desk' },
  { value: 'Dedicated Non-smoking Floors', label: 'Dedicated Non-smoking Floors' },
  { value: 'Desk', label: 'Desk' },
  { value: 'Disabled Facilities', label: 'Disabled Facilities' },
  { value: 'Disabled Facilities-Assistance', label: 'Disabled Facilities-Assistance' },
  { value: 'Dishwasher', label: 'Dishwasher' },
  { value: 'Drycleaning', label: 'Drycleaning' },
  { value: 'Dual Key Apartment', label: 'Dual Key Apartment' },
  { value: 'Eco Accredited', label: 'Eco Accredited' },
  { value: 'Eftpos Facilities', label: 'Eftpos Facilities' },
  { value: 'Electric Blanket', label: 'Electric Blanket' },
  { value: 'Ensuite', label: 'Ensuite' },
  { value: 'Entertainment', label: 'Entertainment' },
  { value: 'Equipment Hire', label: 'Equipment Hire' },
  { value: 'Established Gardens', label: 'Established Gardens' },
  { value: 'Exercise Equipment', label: 'Exercise Equipment' },
  { value: 'Facsimile', label: 'Facsimile' },
  { value: 'Fireplace-Gas', label: 'Fireplace-Gas' },
  { value: 'Fireplace-Wood', label: 'Fireplace-Wood' },
  { value: 'Free Car Charging Station', label: 'Free Car Charging Station' },
  { value: 'Free In Room Internet', label: 'Free In Room Internet' },
  { value: 'Free Morning Paper', label: 'Free Morning Paper' },
  { value: 'Free Pay TV', label: 'Free Pay TV' },
  { value: 'Free Public Area Internet', label: 'Free Public Area Internet' },
  { value: 'Full Cooking Facilities', label: 'Full Cooking Facilities' },
  { value: 'Games Room', label: 'Games Room' },
  { value: 'Gaming Machines', label: 'Gaming Machines' },
  { value: 'Golf', label: 'Golf' },
  { value: 'Groups', label: 'Groups' },
  { value: 'Guest Laundry', label: 'Guest Laundry' },
  { value: 'Guest Lounge', label: 'Guest Lounge' },
  { value: 'Gymnasium', label: 'Gymnasium' },
  { value: 'Hairdresser', label: 'Hairdresser' },
  { value: 'Hairdryer', label: 'Hairdryer' },
  { value: 'Heater', label: 'Heater' },
  { value: 'High Rise (3 Floors or More)', label: 'High Rise (3 Floors or More)' },
  { value: 'Homestay/Farmstay', label: 'Homestay/Farmstay' },
  { value: 'ISD Phone In Room', label: 'ISD Phone In Room' },
  { value: 'In House Movies', label: 'In House Movies' },
  { value: 'Insect Screens', label: 'Insect Screens' },
  { value: 'Interconnecting Rooms', label: 'Interconnecting Rooms' },
  { value: 'Internet Access Broadband', label: 'Internet Access Broadband' },
  { value: 'Internet Access Dial-up', label: 'Internet Access Dial-up' },
  { value: 'Internet Access Wireless', label: 'Internet Access Wireless' },
  { value: 'Internet Facilities', label: 'Internet Facilities' },
  { value: 'Interpreter Services', label: 'Interpreter Services' },
  { value: 'Ipod Connection/Dock', label: 'Ipod Connection/Dock' },
  { value: 'Iron In Room', label: 'Iron In Room' },
  { value: 'Iron in Guest Laundry', label: 'Iron in Guest Laundry' },
  { value: 'Kids Club', label: 'Kids Club' },
  { value: 'Kiosk', label: 'Kiosk' },
  { value: 'LCD/Plasma Television', label: 'LCD/Plasma Television' },
  { value: 'Library', label: 'Library' },
  { value: 'Lift', label: 'Lift' },
  { value: 'Limited Cooking Facilities', label: 'Limited Cooking Facilities' },
  { value: 'Linen Provided/Incl in Tariff', label: 'Linen Provided/Incl in Tariff' },
  { value: 'Low Rise (2 Floors or Less)', label: 'Low Rise (2 Floors or Less)' },
  { value: 'Marina Facilities', label: 'Marina Facilities' },
  { value: 'Masseur/Masseuse', label: 'Masseur/Masseuse' },
  { value: 'Medical Facilities', label: 'Medical Facilities' },
  { value: 'Microwave Oven', label: 'Microwave Oven' },
  { value: 'Mini Bar', label: 'Mini Bar' },
  { value: 'Night Entertainment', label: 'Night Entertainment' },
  { value: 'Non Smoking Property', label: 'Non Smoking Property' },
  { value: 'Open Fireplace', label: 'Open Fireplace' },
  { value: 'Outdoor Shower', label: 'Outdoor Shower' },
  { value: 'Parking - Outdoor Parking', label: 'Parking - Outdoor Parking' },
  { value: 'Parking - Security Undercover', label: 'Parking - Security Undercover' },
  { value: 'Parking/Car Space Available', label: 'Parking/Car Space Available' },
  { value: 'Patio', label: 'Patio' },
  { value: 'Pay Phone', label: 'Pay Phone' },
  { value: 'Pets Allowed', label: 'Pets Allowed' },
  { value: 'Photocopier', label: 'Photocopier' },
  { value: 'Pool', label: 'Pool' },
  { value: 'Pool - Heated', label: 'Pool - Heated' },
  { value: 'Pool - Heated (Winter Only)', label: 'Pool - Heated (Winter Only)' },
  { value: 'Pool - Indoor', label: 'Pool - Indoor' },
  { value: 'Pool - Lap Pool', label: 'Pool - Lap Pool' },
  { value: 'Pool Lagoon Pool', label: 'Pool Lagoon Pool' },
  { value: 'Porter Service', label: 'Porter Service' },
  { value: 'Private Bathroom', label: 'Private Bathroom' },
  { value: 'Private Bathroom Accessible', label: 'Private Bathroom Accessible' },
  { value: 'Private Plunge Pool', label: 'Private Plunge Pool' },
  { value: 'Recreation Facilities', label: 'Recreation Facilities' },
  { value: 'Refrigerator', label: 'Refrigerator' },
  { value: 'Resort Shop', label: 'Resort Shop' },
  { value: 'Restaurant - BYO', label: 'Restaurant - BYO' },
  { value: 'Restaurant - Licensed', label: 'Restaurant - Licensed' },
  { value: 'Restaurant - On Premises', label: 'Restaurant - On Premises' },
  { value: 'Rooftop Pool', label: 'Rooftop Pool' },
  { value: 'Room Service Available', label: 'Room Service Available' },
  { value: 'Safe', label: 'Safe' },
  { value: 'Safety Deposit Box Available', label: 'Safety Deposit Box Available' },
  { value: 'Sauna', label: 'Sauna' },
  { value: 'Secretarial Services', label: 'Secretarial Services' },
  { value: 'Security Intercom', label: 'Security Intercom' },
  { value: 'Security System', label: 'Security System' },
  { value: 'Shared Bathroom', label: 'Shared Bathroom' },
  { value: 'Ski equipment drying room', label: 'Ski equipment drying room' },
  { value: 'Ski equipment secure storage', label: 'Ski equipment secure storage' },
  { value: 'Spa', label: 'Spa' },
  { value: 'Spa In Bath', label: 'Spa In Bath' },
  { value: 'Spa on Deck/Balcony', label: 'Spa on Deck/Balcony' },
  { value: 'Squash Court', label: 'Squash Court' },
  { value: 'Standard Television', label: 'Standard Television' },
  { value: 'Steam Room', label: 'Steam Room' },
  { value: 'Surround Sound System', label: 'Surround Sound System' },
  { value: 'Tea/Coffee Making Facilities', label: 'Tea/Coffee Making Facilities' },
  { value: 'Telephone', label: 'Telephone' },
  { value: 'Tennis Court - Full Size', label: 'Tennis Court - Full Size' },
  { value: 'Tennis Court - Half Size', label: 'Tennis Court - Half Size' },
  { value: 'Turndown Service', label: 'Turndown Service' },
  { value: 'Video Games', label: 'Video Games' },
  { value: 'Washing Machine', label: 'Washing Machine' },
  { value: 'Water Sports Gear', label: 'Water Sports Gear' },
  { value: 'Wood Heater', label: 'Wood Heater' },
  { value: 'Yoga Studio', label: 'Yoga Studio' },
];

export const howTheyHeard = [
  { value: 'coworker-colleague', label: 'Coworker / Colleague' },
  { value: 'heard-from-a-friend', label: 'Industry Peer / Friend' },
  { value: 'search-engine', label: 'Search Engine (Google, Bing, Yahoo, etc.)' },
  { value: 'intl-tourism-event', label: 'International Tourism Event' },
  { value: 'nat-tourism-event', label: 'National Tourism Event' },
  { value: 'reg-tourism-event', label: 'Regional Tourism Event' },
  { value: 'tc-request-contract', label: 'TourConnect Invitation / Email' },
  { value: 'association-organization', label: 'Tourism Association / Organization' },
  { value: 'media-publication', label: 'Tourism Media / Publication' },
  { value: 'other', label: 'Other' },
];

export const countries = [
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Algeria', label: 'Algeria' },
  { value: 'American Samoa', label: 'American Samoa' },
  { value: 'Andorra', label: 'Andorra' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Anguilla', label: 'Anguilla' },
  { value: 'Antarctica', label: 'Antarctica' },
  { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Aruba', label: 'Aruba' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Barbados', label: 'Barbados' },
  { value: 'Belarus', label: 'Belarus' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Bermuda', label: 'Bermuda' },
  { value: 'Bhutan', label: 'Bhutan' },
  { value: 'Bolivia', label: 'Bolivia' },
  { value: 'Bonaire, Sint Eustatius and Saba', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Bouvet Island', label: 'Bouvet Island' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'British Indian Ocean Territory', label: 'British Indian Ocean Territory' },
  { value: 'Brunei Darussalam', label: 'Brunei Darussalam' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Cape Verde', label: 'Cape Verde' },
  { value: 'Cayman Islands', label: 'Cayman Islands' },
  { value: 'Central African Republic', label: 'Central African Republic' },
  { value: 'Chad', label: 'Chad' },
  { value: 'Chile', label: 'Chile' },
  { value: 'China', label: 'China' },
  { value: 'Christmas Island', label: 'Christmas Island' },
  { value: 'Cocos (Keeling) Islands', label: 'Cocos (Keeling) Islands' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Comoros', label: 'Comoros' },
  { value: 'Congo', label: 'Congo' },
  { value: 'Congo, The Democratic Republic of the', label: 'Congo, The Democratic Republic of the' },
  { value: 'Cook Islands', label: 'Cook Islands' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Curaçao', label: 'Curaçao' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Czech Republic', label: 'Czech Republic' },
  { value: 'Côte D\'Ivoire', label: 'Côte D\'Ivoire' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Dominica', label: 'Dominica' },
  { value: 'Dominican Republic', label: 'Dominican Republic' },
  { value: 'Ecuador', label: 'Ecuador' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
  { value: 'Eritrea', label: 'Eritrea' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Ethiopia', label: 'Ethiopia' },
//  { value: 'European Economic and Monetary Union area', label: 'European Economic and Monetary Union area' },
  { value: 'Falkland Islands (Malvinas)', label: 'Falkland Islands (Malvinas)' },
  { value: 'Faroe Islands', label: 'Faroe Islands' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Finland', label: 'Finland' },
  { value: 'France', label: 'France' },
  { value: 'French Guiana', label: 'French Guiana' },
  { value: 'French Polynesia', label: 'French Polynesia' },
  { value: 'French Southern Territories', label: 'French Southern Territories' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambia', label: 'Gambia' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Gibraltar', label: 'Gibraltar' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Greenland', label: 'Greenland' },
  { value: 'Grenada', label: 'Grenada' },
  { value: 'Guadeloupe', label: 'Guadeloupe' },
  { value: 'Guam', label: 'Guam' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guernsey', label: 'Guernsey' },
  { value: 'Guinea', label: 'Guinea' },
  { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Heard Island and McDonald Islands', label: 'Heard Island and McDonald Islands' },
  { value: 'Vatican City', label: 'Vatican City' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Hong Kong', label: 'Hong Kong' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'India', label: 'India' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Isle of Man', label: 'Isle of Man' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Jersey', label: 'Jersey' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kiribati', label: 'Kiribati' },
  { value: 'North Korea', label: 'North Korea' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Macao', label: 'Macao' },
  { value: 'Macedonia', label: 'Macedonia' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Malaysia', label: 'Malaysia' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Marshall Islands', label: 'Marshall Islands' },
  { value: 'Martinique', label: 'Martinique' },
  { value: 'Mauritania', label: 'Mauritania' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Mayotte', label: 'Mayotte' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Micronesia', label: 'Micronesia' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Morocco', label: 'Morocco' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Namibia', label: 'Namibia' },
  { value: 'Nauru', label: 'Nauru' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Netherlands Antilles', label: 'Netherlands Antilles' },
  { value: 'New Caledonia', label: 'New Caledonia' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'Niue', label: 'Niue' },
  { value: 'Norfolk Island', label: 'Norfolk Island' },
  { value: 'Northern Mariana Islands', label: 'Northern Mariana Islands' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Palau', label: 'Palau' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Pitcairn', label: 'Pitcairn' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Puerto Rico', label: 'Puerto Rico' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Russia', label: 'Russia' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Réunion', label: 'Réunion' },
  { value: 'Saint Barthélemy', label: 'Saint Barthélemy' },
  { value: 'Saint Helena, Ascension and Tristan Da Cunha', label: 'Saint Helena, Ascension and Tristan Da Cunha' },
  { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
  { value: 'Saint Lucia', label: 'Saint Lucia' },
  { value: 'Saint Martin (French part)', label: 'Saint Martin (French part)' },
  { value: 'Saint Pierre and Miquelon', label: 'Saint Pierre and Miquelon' },
  { value: 'Saint Vincent and The Grenadines', label: 'Saint Vincent and The Grenadines' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Seychelles', label: 'Seychelles' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Sint Maarten (Dutch part)', label: 'Sint Maarten (Dutch part)' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Solomon Islands', label: 'Solomon Islands' },
  { value: 'Somalia', label: 'Somalia' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'South Georgia and the South Sandwich Islands', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'South Sudan', label: 'South Sudan' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'Svalbard and Jan Mayen', label: 'Svalbard and Jan Mayen' },
  { value: 'Swaziland', label: 'Swaziland' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Syria', label: 'Syria' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Tanzania', label: 'Tanzania' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Timor-Leste', label: 'Timor-Leste' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Tokelau', label: 'Tokelau' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
  { value: 'Tunisia', label: 'Tunisia' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'Turks and Caicos Islands', label: 'Turks and Caicos Islands' },
  { value: 'Tuvalu', label: 'Tuvalu' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'United States', label: 'United States' },
  { value: 'United States Minor Outlying Islands', label: 'United States Minor Outlying Islands' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Uzbekistan', label: 'Uzbekistan' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'Virgin Islands, British', label: 'Virgin Islands, British' },
  { value: 'Virgin Islands, U.S.', label: 'Virgin Islands, U.S.' },
  { value: 'Wallis And Futuna', label: 'Wallis And Futuna' },
  { value: 'Western Sahara', label: 'Western Sahara' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Zambia', label: 'Zambia' },
  { value: 'Zimbabwe', label: 'Zimbabwe' },
];

export const taxTypes = [
  { value: 'VAT', label: 'VAT' },
  { value: 'GST', label: 'GST' },
  { value: 'No sales tax', label: 'No sales tax' },
  { value: 'Sales Tax', label: 'Sales Tax' },
  { value: 'ICMS', label: 'ICMS' },
  { value: 'GST + PST', label: 'GST + PST' },
  { value: 'HST', label: 'HST' },
  { value: 'GST + QST', label: 'GST + QST' },
  { value: 'IGIC', label: 'IGIC' },
  { value: 'ISV', label: 'ISV' },
  { value: 'Consumption tax', label: 'Consumption tax' },
  { value: 'Commercial tax', label: 'Commercial tax' },
  { value: 'ITBM Tax (VAT)', label: 'ITBM Tax (VAT)' },
  { value: 'Federal VAT (IGV)', label: 'Federal VAT (IGV)' },
  { value: 'IVU', label: 'IVU' },
  { value: 'MwSt/USt', label: 'MwSt/USt' },
  { value: 'BTW', label: 'BTW' },
  { value: 'TVA', label: 'TVA' },
  { value: 'MWSt', label: 'MWSt' },
  { value: 'PDV', label: 'PDV' },
  { value: 'DPH', label: 'DPH' },
  { value: 'Moms', label: 'Moms' },
  { value: 'km', label: 'km' },
  { value: 'ALV', label: 'ALV' },
  { value: 'CBL', label: 'CBL' },
  { value: 'IVA', label: 'IVA' },
  { value: 'PVN', label: 'PVN' },
  { value: 'PVM', label: 'PVM' },
  { value: 'PTU', label: 'PTU' },
  { value: 'DDV', label: 'DDV' },
  { value: 'TVSH', label: 'TVSH' },
  { value: 'IGI', label: 'IGI' },
  { value: 'AAH', label: 'AAH' },
  { value: 'Musok', label: 'Musok' },
  { value: 'IPI', label: 'IPI' },
  { value: 'ISS', label: 'ISS' },
  { value: 'ITBIS', label: 'ITBIS' },
  { value: 'MVG', label: 'MVG' },
  { value: 'DGhG', label: 'DGhG' },
  { value: 'VSK', label: 'VSK' },
  { value: 'PPN', label: 'PPN' },
  { value: 'RVAT', label: 'RVAT' },
  { value: 'KDV', label: 'KDV' },
  { value: 'GTGT', label: 'GTGT' },
];

export const timeSelect15MinsInterval = [
  { value: '0:00am', label: '0:00am' },
  { value: '0:15am', label: '0:15am' },
  { value: '0:30am', label: '0:30am' },
  { value: '0:45am', label: '0:45am' },
  { value: '1:00am', label: '1:00am' },
  { value: '1:15am', label: '1:15am' },
  { value: '1:30am', label: '1:30am' },
  { value: '1:45am', label: '1:45am' },
  { value: '2:00am', label: '2:00am' },
  { value: '2:15am', label: '2:15am' },
  { value: '2:30am', label: '2:30am' },
  { value: '2:45am', label: '2:45am' },
  { value: '3:00am', label: '3:00am' },
  { value: '3:15am', label: '3:15am' },
  { value: '3:30am', label: '3:30am' },
  { value: '3:45am', label: '3:45am' },
  { value: '4:00am', label: '4:00am' },
  { value: '4:15am', label: '4:15am' },
  { value: '4:30am', label: '4:30am' },
  { value: '4:45am', label: '4:45am' },
  { value: '5:00am', label: '5:00am' },
  { value: '5:15am', label: '5:15am' },
  { value: '5:30am', label: '5:30am' },
  { value: '5:45am', label: '5:45am' },
  { value: '6:00am', label: '6:00am' },
  { value: '6:15am', label: '6:15am' },
  { value: '6:30am', label: '6:30am' },
  { value: '6:45am', label: '6:45am' },
  { value: '7:00am', label: '7:00am' },
  { value: '7:15am', label: '7:15am' },
  { value: '7:30am', label: '7:30am' },
  { value: '7:45am', label: '7:45am' },
  { value: '8:00am', label: '8:00am' },
  { value: '8:15am', label: '8:15am' },
  { value: '8:30am', label: '8:30am' },
  { value: '8:45am', label: '8:45am' },
  { value: '9:00am', label: '9:00am' },
  { value: '9:15am', label: '9:15am' },
  { value: '9:30am', label: '9:30am' },
  { value: '9:45am', label: '9:45am' },
  { value: '10:00am', label: '10:00am' },
  { value: '10:15am', label: '10:15am' },
  { value: '10:30am', label: '10:30am' },
  { value: '10:45am', label: '10:45am' },
  { value: '11:00am', label: '11:00am' },
  { value: '11:15am', label: '11:15am' },
  { value: '11:30am', label: '11:30am' },
  { value: '11:45am', label: '11:45am' },
  { value: '12:00pm', label: '12:00pm' },
  { value: '12:15pm', label: '12:15pm' },
  { value: '12:30pm', label: '12:30pm' },
  { value: '12:45pm', label: '12:45pm' },
  { value: '1:00pm', label: '1:00pm' },
  { value: '1:15pm', label: '1:15pm' },
  { value: '1:30pm', label: '1:30pm' },
  { value: '1:45pm', label: '1:45pm' },
  { value: '2:00pm', label: '2:00pm' },
  { value: '2:15pm', label: '2:15pm' },
  { value: '2:30pm', label: '2:30pm' },
  { value: '2:45pm', label: '2:45pm' },
  { value: '3:00pm', label: '3:00pm' },
  { value: '3:15pm', label: '3:15pm' },
  { value: '3:30pm', label: '3:30pm' },
  { value: '3:45pm', label: '3:45pm' },
  { value: '4:00pm', label: '4:00pm' },
  { value: '4:15pm', label: '4:15pm' },
  { value: '4:30pm', label: '4:30pm' },
  { value: '4:45pm', label: '4:45pm' },
  { value: '5:00pm', label: '5:00pm' },
  { value: '5:15pm', label: '5:15pm' },
  { value: '5:30pm', label: '5:30pm' },
  { value: '5:45pm', label: '5:45pm' },
  { value: '6:00pm', label: '6:00pm' },
  { value: '6:15pm', label: '6:15pm' },
  { value: '6:30pm', label: '6:30pm' },
  { value: '6:45pm', label: '6:45pm' },
  { value: '7:00pm', label: '7:00pm' },
  { value: '7:15pm', label: '7:15pm' },
  { value: '7:30pm', label: '7:30pm' },
  { value: '7:45pm', label: '7:45pm' },
  { value: '8:00pm', label: '8:00pm' },
  { value: '8:15pm', label: '8:15pm' },
  { value: '8:30pm', label: '8:30pm' },
  { value: '8:45pm', label: '8:45pm' },
  { value: '9:00pm', label: '9:00pm' },
  { value: '9:15pm', label: '9:15pm' },
  { value: '9:30pm', label: '9:30pm' },
  { value: '9:45pm', label: '9:45pm' },
  { value: '10:00pm', label: '10:00pm' },
  { value: '10:15pm', label: '10:15pm' },
  { value: '10:30pm', label: '10:30pm' },
  { value: '10:45pm', label: '10:45pm' },
  { value: '11:00pm', label: '11:00pm' },
  { value: '11:15pm', label: '11:15pm' },
  { value: '11:30pm', label: '11:30pm' },
  { value: '11:45pm', label: '11:45pm' },
];

export const currencies = [
  { value: 'AED', label: 'AED' },
  { value: 'AFN', label: 'AFN' },
  { value: 'AMD', label: 'AMD' },
  { value: 'ANG', label: 'ANG' },
  { value: 'AOA', label: 'AOA' },
  { value: 'ARS', label: 'ARS' },
  { value: 'AUD', label: 'AUD' },
  { value: 'AWG', label: 'AWG' },
  { value: 'AZN', label: 'AZN' },
  { value: 'BAM', label: 'BAM' },
  { value: 'BBD', label: 'BBD' },
  { value: 'BDT', label: 'BDT' },
  { value: 'BGN', label: 'BGN' },
  { value: 'BHD', label: 'BHD' },
  { value: 'BIF', label: 'BIF' },
  { value: 'BMD', label: 'BMD' },
  { value: 'BND', label: 'BND' },
  { value: 'BOB', label: 'BOB' },
  { value: 'BOV', label: 'BOV' },
  { value: 'BRL', label: 'BRL' },
  { value: 'BSD', label: 'BSD' },
  { value: 'BTN', label: 'BTN' },
  { value: 'BWP', label: 'BWP' },
  { value: 'BYR', label: 'BYR' },
  { value: 'BZD', label: 'BZD' },
  { value: 'CAD', label: 'CAD' },
  { value: 'CDF', label: 'CDF' },
  { value: 'CHE', label: 'CHE' },
  { value: 'CHF', label: 'CHF' },
  { value: 'CHW', label: 'CHW' },
  { value: 'CLF', label: 'CLF' },
  { value: 'CLP', label: 'CLP' },
  { value: 'CNY', label: 'CNY' },
  { value: 'COP', label: 'COP' },
  { value: 'COU', label: 'COU' },
  { value: 'CRC', label: 'CRC' },
  { value: 'CUP', label: 'CUP' },
  { value: 'CVE', label: 'CVE' },
  { value: 'CYP', label: 'CYP' },
  { value: 'CZK', label: 'CZK' },
  { value: 'DJF', label: 'DJF' },
  { value: 'DKK', label: 'DKK' },
  { value: 'DOP', label: 'DOP' },
  { value: 'DZD', label: 'DZD' },
  { value: 'EEK', label: 'EEK' },
  { value: 'EGP', label: 'EGP' },
  { value: 'ERN', label: 'ERN' },
  { value: 'ETB', label: 'ETB' },
  { value: 'EUR', label: 'EUR' },
  { value: 'FJD', label: 'FJD' },
  { value: 'FKP', label: 'FKP' },
  { value: 'GBP', label: 'GBP' },
  { value: 'GEL', label: 'GEL' },
  { value: 'GHS', label: 'GHS' },
  { value: 'GIP', label: 'GIP' },
  { value: 'GMD', label: 'GMD' },
  { value: 'GNF', label: 'GNF' },
  { value: 'GTQ', label: 'GTQ' },
  { value: 'GYD', label: 'GYD' },
  { value: 'HKD', label: 'HKD' },
  { value: 'HNL', label: 'HNL' },
  { value: 'HRK', label: 'HRK' },
  { value: 'HTG', label: 'HTG' },
  { value: 'HUF', label: 'HUF' },
  { value: 'IDR', label: 'IDR' },
  { value: 'ILS', label: 'ILS' },
  { value: 'INR', label: 'INR' },
  { value: 'IQD', label: 'IQD' },
  { value: 'IRR', label: 'IRR' },
  { value: 'ISK', label: 'ISK' },
  { value: 'JMD', label: 'JMD' },
  { value: 'JOD', label: 'JOD' },
  { value: 'JPY', label: 'JPY' },
  { value: 'KES', label: 'KES' },
  { value: 'KGS', label: 'KGS' },
  { value: 'KHR', label: 'KHR' },
  { value: 'KMF', label: 'KMF' },
  { value: 'KPW', label: 'KPW' },
  { value: 'KRW', label: 'KRW' },
  { value: 'KWD', label: 'KWD' },
  { value: 'KYD', label: 'KYD' },
  { value: 'KZT', label: 'KZT' },
  { value: 'LAK', label: 'LAK' },
  { value: 'LBP', label: 'LBP' },
  { value: 'LKR', label: 'LKR' },
  { value: 'LRD', label: 'LRD' },
  { value: 'LSL', label: 'LSL' },
  { value: 'LTL', label: 'LTL' },
  { value: 'LVL', label: 'LVL' },
  { value: 'LYD', label: 'LYD' },
  { value: 'MAD', label: 'MAD' },
  { value: 'MDL', label: 'MDL' },
  { value: 'MGA', label: 'MGA' },
  { value: 'MKD', label: 'MKD' },
  { value: 'MMK', label: 'MMK' },
  { value: 'MNT', label: 'MNT' },
  { value: 'MOP', label: 'MOP' },
  { value: 'MRO', label: 'MRO' },
  { value: 'MTL', label: 'MTL' },
  { value: 'MUR', label: 'MUR' },
  { value: 'MVR', label: 'MVR' },
  { value: 'MWK', label: 'MWK' },
  { value: 'MXN', label: 'MXN' },
  { value: 'MXV', label: 'MXV' },
  { value: 'MYR', label: 'MYR' },
  { value: 'MZN', label: 'MZN' },
  { value: 'NAD', label: 'NAD' },
  { value: 'NGN', label: 'NGN' },
  { value: 'NIO', label: 'NIO' },
  { value: 'NOK', label: 'NOK' },
  { value: 'NPR', label: 'NPR' },
  { value: 'NZD', label: 'NZD' },
  { value: 'OMR', label: 'OMR' },
  { value: 'PAB', label: 'PAB' },
  { value: 'PEN', label: 'PEN' },
  { value: 'PGK', label: 'PGK' },
  { value: 'PHP', label: 'PHP' },
  { value: 'PKR', label: 'PKR' },
  { value: 'PLN', label: 'PLN' },
  { value: 'PYG', label: 'PYG' },
  { value: 'QAR', label: 'QAR' },
  { value: 'RON', label: 'RON' },
  { value: 'RSD', label: 'RSD' },
  { value: 'RUB', label: 'RUB' },
  { value: 'RWF', label: 'RWF' },
  { value: 'SAR', label: 'SAR' },
  { value: 'SBD', label: 'SBD' },
  { value: 'SCR', label: 'SCR' },
  { value: 'SDG', label: 'SDG' },
  { value: 'SEK', label: 'SEK' },
  { value: 'SGD', label: 'SGD' },
  { value: 'SHP', label: 'SHP' },
  { value: 'SKK', label: 'SKK' },
  { value: 'SLL', label: 'SLL' },
  { value: 'SOS', label: 'SOS' },
  { value: 'SRD', label: 'SRD' },
  { value: 'STD', label: 'STD' },
  { value: 'SYP', label: 'SYP' },
  { value: 'SZL', label: 'SZL' },
  { value: 'THB', label: 'THB' },
  { value: 'TJS', label: 'TJS' },
  { value: 'TMM', label: 'TMM' },
  { value: 'TND', label: 'TND' },
  { value: 'TOP', label: 'TOP' },
  { value: 'TRY', label: 'TRY' },
  { value: 'TTD', label: 'TTD' },
  { value: 'TWD', label: 'TWD' },
  { value: 'TZS', label: 'TZS' },
  { value: 'UAH', label: 'UAH' },
  { value: 'UGX', label: 'UGX' },
  { value: 'USD', label: 'USD' },
  { value: 'USN', label: 'USN' },
  { value: 'USS', label: 'USS' },
  { value: 'UYU', label: 'UYU' },
  { value: 'UZS', label: 'UZS' },
  { value: 'VEB', label: 'VEB' },
  { value: 'VND', label: 'VND' },
  { value: 'VUV', label: 'VUV' },
  { value: 'WST', label: 'WST' },
  { value: 'XAF', label: 'XAF' },
  { value: 'XAG', label: 'XAG' },
  { value: 'XAU', label: 'XAU' },
  { value: 'XBA', label: 'XBA' },
  { value: 'XBB', label: 'XBB' },
  { value: 'XBC', label: 'XBC' },
  { value: 'XBD', label: 'XBD' },
  { value: 'XCD', label: 'XCD' },
  { value: 'XDR', label: 'XDR' },
  { value: 'XFO', label: 'XFO' },
  { value: 'XFU', label: 'XFU' },
  { value: 'XOF', label: 'XOF' },
  { value: 'XPD', label: 'XPD' },
  { value: 'XPF', label: 'XPF' },
  { value: 'XPT', label: 'XPT' },
  { value: 'XTS', label: 'XTS' },
  { value: 'XXX', label: 'XXX' },
  { value: 'YER', label: 'YER' },
  { value: 'ZAR', label: 'ZAR' },
  { value: 'ZMK', label: 'ZMK' },
  { value: 'ZWD', label: 'ZWD' },
];

export const months = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
  { value: 11, label: 11 },
  { value: 12, label: 12 },
];

export const years = [
  { value: 2016, label: 2016 },
  { value: 2017, label: 2017 },
  { value: 2018, label: 2018 },
  { value: 2019, label: 2019 },
  { value: 2020, label: 2020 },
  { value: 2021, label: 2021 },
  { value: 2022, label: 2022 },
  { value: 2023, label: 2023 },
  { value: 2024, label: 2024 },
  { value: 2025, label: 2025 },
];



// WEBPACK FOOTER //
// ./src/app/utils/select-fields.js